import {Box} from "@mui/material";
import PageHeader from "@/global/components/PageHeader";
import {wrapperSx} from "@/global/helpers/globalstyles";
import {TicketInfoMain} from "@/modules/tickets/pages/info/components";

export function TicketInfoPage() {
    return (
        <Box
            className="App"
            sx={{height: '100%', display: 'flex', flexDirection: 'column'}}
        >
            <PageHeader/>
            <Box sx={wrapperSx}>
                <TicketInfoMain/>
            </Box>
        </Box>
    );
}